import { h } from "omi";

export function GoogleIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" fill="none">
      <g clip-path="url(#a)">
        <path
          d="M23.7663 13.2155c0-.8158-.0662-1.6359-.2073-2.4384H12.2402v4.621h6.4818a5.5547 5.5547 0 0 1-2.3987 3.6465v2.9983h3.867c2.2708-2.09 3.576-5.1765 3.576-8.8274Z"
          fill="#4285F4"
        />
        <path
          d="M12.2401 24.9398c3.2365 0 5.9658-1.0627 7.9544-2.8969l-3.8669-2.9984c-1.0759.732-2.4649 1.1464-4.0831 1.1464-3.1306 0-5.785-2.112-6.7375-4.9516H1.5166v3.0909c2.0371 4.0522 6.1863 6.6096 10.7235 6.6096Z"
          fill="#34A853"
        />
        <path
          d="M5.5028 15.2392a7.1877 7.1877 0 0 1 0-4.5945v-3.091h-3.986a12.0102 12.0102 0 0 0 0 10.7764l3.986-3.0909Z"
          fill="#FBBC04"
        />
        <path
          d="M12.2401 5.6886c1.7108-.0264 3.3643.6173 4.6033 1.799l3.4261-3.426C18.1001 2.0245 15.2208.9045 12.2401.9398c-4.5372 0-8.6864 2.5574-10.7235 6.614l3.986 3.0909c.948-2.844 3.6069-4.956 6.7375-4.956Z"
          fill="#EA4335"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" transform="translate(0 .939)" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
